import styled from 'styled-components';

interface PilsProps {
    isFull?: boolean;
    isRed?: boolean;
    xl?: boolean;
    isImage?: boolean;
}

export const PilsWrapper = styled.div<PilsProps>`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    gap: 5px;
    padding: ${({ isFull }) => (isFull ? '0' : '5px 8px')};
    font-size: ${({ xl }) => (xl ? '24px' : '14px')};
    color: ${({ xl, isRed, isImage }) => {
    if (xl) return '#000';
    if (isImage) return '#fff'; // 🛠️ fixed: white if image
    if (isRed) return '#fff';
    return '#535353';
  }};
    background: ${({ isRed, isFull }) => {
    if (isRed) return '#cc0a0a';
    return isFull ? 'transparent' : '#252525';
  }};
    border: ${({ xl, isFull, isRed }) => {
    if (xl || isRed || isFull) return 'none';
    return '1px solid transparent';
  }};

    svg {
        width: ${({ xl }) => (xl ? '24px' : '16px')};
        height: ${({ xl }) => (xl ? '24px' : '16px')};
    }
`;

export const IconWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 25px;
    height: 25px; 
`;
